const product = {
  product: "उत्पाद", // translated 
  products: "उत्पादों", // translated 
  information: "जानकारी", // translated 
  additionalInformation: "अतिरिक्त जानकारी", // translated 
  contactUs: "हमसे संपर्क करें", // translated 
  contactUsText: "क्या आप अपने टूर को अपनी पसंद के अनुसार बनाना चाहते हैं या आपके कोई अन्य प्रश्न हैं?", // translated 
  dropUsAnEmail: "हमें ईमेल भेजें", // translated 
  viewLess: "कम देखें", // translated 
  viewMore: "और देखें", // translated 
  less: "कम", // translated 
  more: "अधिक", // translated 
  highlights: "हाइलाइट", // translated 
  inclusions: "समावेशन", // translated 
  exclusions: "बहिष्कार", // translated 
  pleaseWait: "कृपया प्रतीक्षा करें...", // translated 
  tourType: "यात्रा का प्रकार", // translated 
  search: "खोज", // translated 
  available: "उपलब्ध", // translated 
  availableTours: "उपलब्ध टूर", // translated 
  sortBy: "इसके अनुसार क्रमबद्ध करें", // translated 
  priceLowToHigh: "कीमतों का उतार - चढ़ाव", // translated 
  priceHighToLow: "कीमत: उच्च से निम्न", // translated 
  mostPopular: "सबसे लोकप्रिय", // translated 
  roomOnly: "सिर्फ कमरा", // translated 
  bedAndBreakfast: "बिस्तर और नाश्ता", // translated 
  halfBoard: "समुचित व्यवस्था", // translated 
  fullBoard: "पूर्ण बोर्ड", // translated 
  allInclusive: "सभी समावेशी", // translated 
  viewDetails: "विवरण देखें", // translated 
  close: "बंद करना", // translated 
  at: "पर", // At dat, // translated 
  person: "व्यक्ति", // translated 
  cancellationPolicy: "रद्द करने की नीति", // translated 
  cancellationIs: "रद्दीकरण है", // translated 
  to: "को", // translated 
  bookingRemarks: "बुकिंग संबंधी टिप्पणियाँ", // translated 
  totalPrice: "कुल कीमत", // translated 
  back: "पीछे", // translated 
  bookNow: "अभी बुक करें", // translated 
  minutes: "मिनट", // translated 
  visitDuration: "यात्रा की अवधि", // translated 
  itinerary: "यात्रा कार्यक्रम", // translated 
  airportToHotel: "हवाई अड्डे से होटल तक", // translated 
  hotelToAirport: "होटल से हवाई अड्डे तक", // translated 
  details: "विवरण", // translated 
  servicesDetails: "सेवाओं का विवरण", // translated 
  services: "सेवाएं", // translated 
  day: "दिन", // translated 
  next: "अगला", // translated 
  nextStep: "अगला कदम", // translated 
  skip: "छोडना", // translated 
  remarks: "टिप्पणी", // translated 
  optional: "वैकल्पिक", // translated 
  guests: "अतिथियों", // translated 
  payment: "भुगतान", // translated 
  pickup: "उठाना", // translated 
  featuredPackage: "विशेष पैकेज", // translated 
  flights: "टिकट", // translated 
  accommodation: "आवास", // translated 
  transfers: "स्थानांतरण", // translated 
  tours: "टूर्स", // translated 
  experiences: "अनुभव", // translated 
  featuredTour: "विशेष भ्रमण", // translated 
  From: "से", // translated 
  Accommodation: "आवास", // translated 
  approxDuration: "लगभग अवधि", // translated 
  travellerInformation: "यात्री जानकारी", // translated 
  bookingOverview: "बुकिंग का अवलोकन", // translated 
  checkout: "चेक आउट", // translated 
  paymentFailed: "भुगतान विफल रही", // translated 
  paymentSuccess: "भुगतान सफल", // translated 
  night: "रात", // translated 
  nights: "नाइट्स", // translated 
  viewEscapes: "एस्केप देखें", // translated 
  viewExperience: "अनुभव देखें", // translated 
  escapeType: "एस्केप टाइप", // translated 
  adultsOnly: "केवल वयस्कों के लिए", // translated 
  totalDuration: "कुल अवधि", // translated 
  options: "विकल्प", // translated 
  departingAirport: "प्रस्थान हवाई अड्डा", // translated 
  childrenAreNotAllowedInThisTour: "इस टूर में बच्चों को अनुमति नहीं है।", // translated 
};


export default product;
